<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M13 2C14.5977 2 15.9037 3.24892 15.9949 4.82373L16 5V8H19C20.5977 8 21.9037 9.24892 21.9949 10.8237L22 11V19C22 20.5977 20.7511 21.9037 19.1763 21.9949L19 22H11C9.40232 22 8.09634 20.7511 8.00509 19.1763L8 19V16H5C3.40232 16 2.09634 14.7511 2.00509 13.1763L2 13V5C2 3.40232 3.24892 2.09634 4.82373 2.00509L5 2H13ZM19 10H16V13C16 14.5977 14.7511 15.9037 13.1763 15.9949L13 16H10V19C10 19.5128 10.386 19.9355 10.8834 19.9933L11 20H19C19.5128 20 19.9355 19.614 19.9933 19.1166L20 19V11C20 10.4872 19.614 10.0645 19.1166 10.0067L19 10Z"
    fill="currentColor"
  />
</svg>
